/* eslint-disable array-callback-return */

import React, { useEffect, useRef, useState } from 'react';
import { Image, Dropdown, Menu } from "antd";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { Row, Col } from "antd";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import { exportChatFile, capitalizeFirstLetter } from "../../../../helpers/utilities";

export const ClientType = (props) => {
    const { title, details } = props;
    const clientType = useRef(null);
    const classes = customStyles();
    const [type, setType] = useState('location_based');
    const [datas, setDatas] = useState([]);
    const [nonPaying, setNonPaying] = useState(0);
    const [paying, setPaying] = useState(0);

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            //downloadImageCommon(netGST.current, title, type);
        }
    }

    useEffect(() => {
        if (details && details?.location_based) {
            setDatas(details?.location_based);
        }
    }, [details]);

    const exportFile = () => {
        let newHead = [['Top Area Sales Total', 'Top City Sales Total', 'Sales Total']];
        exportChatFile(title, newHead);
    }

    const handleChange = (value) => {
        setType(value);
        setDatas(details[value]);
    }

    useEffect(() => {
        let paying = 0; let nonPaying = 0;
        if (datas && Object.keys(datas).length > 0) {
            Object?.entries(datas)?.map(([key, value]) => {
                Object.keys(value).length > 0 && Object?.entries(value)?.map(([k, v]) => {
                    if (v?.paying && v?.paying !== '') {
                        paying += v.paying;
                    }
                    if (v?.nonPaying && v?.nonPaying !== '') {
                        nonPaying += v.nonPaying;
                    }
                });
            })
        }
        setPaying(paying);
        setNonPaying(nonPaying);
    }, [datas]);

    return (
        <div ref={clientType} style={{ height: "100%" }}>
            <div className={clsx(classes.monthlyDiv, classes.clientList)} style={{ height: "100%" }}>
                <div className={clsx(classes.monthlyDivTitle, classes.bold)}>
                    {`${title}`}
                    <span className={classes.hamburgerMenu}>
                        <Dropdown
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </span>
                </div>
                <div className={clsx(classes.chartOverDue)} style={{ border: "none" }}>
                    <Row gutter={5} type="flex">
                        <Col span={12}>
                            <div className={clsx(classes.totalInvoiceDue, classes.bg_green, classes.textAlignRight)}>
                                Total Payable Clients
                                <div className={clsx(classes.daysRowTitle, classes.totalInvoicesAmount, classes.bold)}>{paying}</div>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className={clsx(classes.totalInvoiceDue, classes.product_bg_blue, classes.textAlignRight)}>
                                Total Non-Payable Clients
                                <div className={clsx(classes.daysRowTitle, classes.totalInvoicesAmount, classes.bold)}>{nonPaying}</div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className={clsx(classes.textAlignCenter, classes.clientType)}>
                    <RadioGroup
                        row
                        defaultValue={type}
                        onChange={(e) => handleChange(e.target.value)}>
                        <FormControlLabel value="location_based" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="Sort  By Client Type" />
                        <FormControlLabel value="location_sort" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="Sort By Location" />
                    </RadioGroup>
                </div>
                <Row gutter={5} type="flex" className={clsx(classes.payingLabels, classes.colorGray, classes.margin15t)}>
                    <Col span={9}>{type === 'location_sort' ? 'Location' : 'Client Type'}</Col>
                    <Col span={7} style={{ textAlign: "center" }}>Payable Clients</Col>
                    <Col span={8} style={{ textAlign: "center" }}>Non-Payable Clients</Col>
                </Row>
                <div className={clsx(classes.clientTypeContent, classes.margin10t)}>
                    {
                        datas && Object.keys(datas).length > 0 && Object?.entries(datas)?.map(([key, value]) => (
                            <>
                                <div className={clsx(classes.clientTypeTitle, classes.bold)}>{capitalizeFirstLetter(key)}</div>
                                <div className={clsx(classes.clientTypeRow, classes.margin10t)}>
                                    {
                                        Object.keys(value).length > 0 && Object?.entries(value)?.map(([key, value]) => (
                                            <>
                                                <Row gutter={5} type="flex">
                                                    <Col span={9}><span>{capitalizeFirstLetter(key)}</span></Col>
                                                    <Col span={7} style={{ textAlign: "center" }}><span>{value?.paying || 0}</span></Col>
                                                    <Col span={8} style={{ textAlign: "center" }}><span>{value?.nonPaying || 0}</span></Col>
                                                </Row>
                                            </>
                                        ))
                                    }
                                </div>
                            </>
                        ))
                    }
                </div>
            </div>
        </div>

    );
}